var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex mt-4"},[_c('h2',[_vm._v(_vm._s(_vm.topic))]),_c('h4',{staticClass:"ml-1 discount-text"},[_vm._v(_vm._s(_vm.discounted_price))])]),_c('span',[_vm._v(" "+_vm._s(_vm.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }